import { render, staticRenderFns } from "./libraryPlugin.vue?vue&type=template&id=4b265554&scoped=true&"
import script from "./libraryPlugin.vue?vue&type=script&lang=js&"
export * from "./libraryPlugin.vue?vue&type=script&lang=js&"
import style0 from "./libraryPlugin.vue?vue&type=style&index=0&id=4b265554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b265554",
  null
  
)

export default component.exports